import { IuserStatus } from './types'

export const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
export const DATETIME_FORMAT = 'DD/MM/YYYY HH:mm'

let hostUrl = window.location.origin
let baseUrl = ''

if (isLocalhost) {
  baseUrl = '/sp4'
  hostUrl = window.location.href.split(':3000')[0]
}

export const apiUrl = baseUrl + '/APIs/'
export const appUrl = hostUrl + baseUrl + '/app/'

/*
export const mqttSettings_old = {
  url: 'wss://62848b0a8e5c4c52926b4337dd63dc4a.s1.eu.hivemq.cloud:8884/mqtt',
  options: {
    username: 'user_test',
    password: 'Pass_test1',
  },
}
*/

export const mqttSettings = {
  //url: 'wss://locks.prolevel.uk:9001/mqtt',
  url: 'wss://locks.telpamon.com:9001/mqtt',
  options: {
    username: 'webAdmin',
    password: 'hv7IWz4cDoOn',
  },
}

export const userStatusList: IuserStatus[] = [
  {
    status: 'admin',
    statusName: 'Admin',
  },
  {
    status: 'technical',
    statusName: 'Technical',
  },
]
